/**
 * React Router definition
 */
import { Navigate, useRoutes } from 'react-router-dom';

// Page layouts
import UserLayout from './layouts/dashboard/UserLayout';
import AdminLayout from './layouts/dashboard/AdminLayout';
import SimpleLayout from './layouts/simple';

// Initial pages
import LoginPage from './pages/LoginPage';
import RegistrationPage from './pages/RegistrationPage';
import ResetForgetPasswordPage from './pages/ResetForgetPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import Page404 from './pages/Page404';
import Maintenance from './pages/Maintenance';

// User section pages
import UserDashboard from './pages/user/Dashboard';
import CalendarPage from './pages/user/CalendarPage';
import NewsletterPage from './pages/user/NewsletterPage';
import SurveyPage from './pages/user/SurveyPage';
import ProfilePage from './pages/user/ProfilePage';
import UserOrganization from './pages/user/UserOrganization';
import UserFederation from './pages/user/UserFederation';
import UserFederationDetail from './pages/user/UserFederationDetail';
import UserFederationChild from './pages/user/UserFederationChild';
import UserPositionDetail from './pages/user/UserPositionDetail';
import BadgePage from './pages/user/BadgePage';

// Admin section pages
import AdminDashboard from './pages/admin/Dashboard';
import Organization from './pages/admin/Organization';
import Users from './pages/admin/Users';
import Cards from './pages/admin/Cards';
import Newsletter from './pages/admin/Newsletter';
import AdminCalendar from './pages/admin/Calendar';
import Surveys from './pages/admin/Survey';
import SurveyDetailPage from './pages/admin/SurveyDetail';
import Report from './pages/admin/Report';
import Campaigns from './pages/admin/Campaigns';
import CampaignDetail from './pages/admin/CampaignDetail';
import FederationDetail from './pages/admin/FederationDetail';
import UserDetails from './pages/admin/UserDetails';
import FederationUser from './pages/admin/FederationUser';
import PositionDetail from './pages/admin/PositionDetail';
import FederationChild from './pages/admin/FederationChild';
import Federation from './pages/admin/Federation';
import NewsletterNew from './pages/admin/NewsletterNew';
import AdminNewsletterDetail from './pages/admin/NewsletterDetail';
import BankTransfers from './pages/admin/BankTransfers';
import BankTransfersDetail from './pages/admin/BankTransfersDetail';
import BankPaymentBatch from './pages/admin/BankPaymentBatch';
import BankPaymentBatchDetail from './pages/admin/BankPaymentBatchDetail';
import UserData from './pages/admin/UserData';
import CityFiscalCode from './pages/admin/CityFiscalCode';
import DataImport from './pages/admin/DataImport/DataImport';

/**
 * @returns Router definitions
 */
export default function Router() {
 const routes = useRoutes([
    {
      path: '/user',
      element: <UserLayout />,
      children: [
        { path: 'dashboard', element: <UserDashboard /> },
        { path: 'profile', element: <ProfilePage /> },
        { path: 'newsletter', element: <NewsletterPage /> },
        { path: 'organization', element: <UserOrganization /> },
        { path: 'organization/federations', element: <UserFederation /> },
        { path: 'organization/federations/federation-details', element: <UserFederationDetail /> },
        { path: 'organization/federations/federation-child', element: <UserFederationChild /> },
        { path: 'organization/charge-details', element: <UserPositionDetail /> },
      ],
    },
    {
      path: '/admin',
      element: <AdminLayout />,
      children: [
        { path: 'dashboard', element: <AdminDashboard /> },
        { path: 'organization', element: <Organization /> },
        { path: 'organization/federations', element: <Federation /> },
        { path: 'organization/federations/federation-details', element: <FederationDetail /> },
        { path: 'organization/federations/federation-child', element: <FederationChild /> },
        { path: 'organization/federations/users', element: <FederationUser /> },
        { path: 'organization/charge-details', element: <PositionDetail /> },
        { path: 'users', element: <Users /> },
        { path: 'users/user-details', element: <UserDetails /> },
        { path: 'users', element: <Users /> },
        { path: 'cards', element: <Cards /> },
        { path: 'newsletter', element: <Newsletter /> },
        { path: 'campaigns', element: <Campaigns /> },
        { path: 'campaigns/campaign-details', element: <CampaignDetail /> },
        { path: 'bank-transfers', element: <BankTransfers /> },
        { path: 'bank-transfers/details', element: <BankTransfersDetail /> },
        { path: 'bankpayment', element: <BankPaymentBatch /> },
        { path: 'bankpayment/details', element: <BankPaymentBatchDetail /> },
        { path: 'userdata', element: <UserData /> },
        { path: 'cityfiscalcode', element: <CityFiscalCode /> },
        { path: 'import', element: <DataImport /> },
      ],
    },
    {
      path: '/',
      element: <LoginPage />,
    },
    {
      path: '/join',
      element: <RegistrationPage />,
    },
    {
      path: '/forgetPassword',
      element: <ResetForgetPasswordPage />,
    },
    {
      path: '/resetPassword',
      element: <ResetPasswordPage />,
    },
    {
      path: '/logout',
      element: <Navigate to="/" />,
    },
    {
      element: <Maintenance/>,
      children: [
        { path: '/maintenance', element: <Maintenance/>},
        { path: '*', element: <Navigate to="/maintenance" /> },
      ]
    },
  ]);

  return routes;
}
